import { useEffect, useRef } from 'react'
import { getRandomFromArray } from 'utils'
import { isOutOfBounds } from '../lib/boundary'

export const useWander = ({ behaviors, cfg, pixelBoundaryRef, isColliding, posRef: _posRef, update }) => {
  const behaviourRef = useRef(getRandomFromArray(behaviors))

  useEffect(() => {
    if (cfg.stationary) return
    let timer
    const tick = () => {
      behaviourRef.current = getRandomFromArray(behaviors)
      timer = setTimeout(tick, cfg.boundaryPeriod ?? (3000 + Math.random() * 2000))
    }
    timer = setTimeout(tick, cfg.boundaryPeriod ?? (4000 + Math.random() * 3000))
    return () => clearTimeout(timer)
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const wanderStep = (pos) => {
    const nextPos = behaviourRef.current(pos, cfg.stride)
    if (!isOutOfBounds(nextPos, pixelBoundaryRef.current) && !isColliding(nextPos)) {
      update(nextPos.x, nextPos.y)
      return true
    }
    behaviourRef.current = getRandomFromArray(behaviors)
    return false
  }

  return { behaviourRef, wanderStep }
}
